import React from 'react'

import { Box, Chip, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
    activeFiltersChip: {
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(1),
    },
}))

interface TenantBillFilters {
    status?: string
    search?: string
    dueDateStart?: string
    dueDateEnd?: string
    minAmount?: string
    maxAmount?: string
    paymentStatus?: string
    isOverdue?: string
    minAmountPaid?: string
    maxAmountPaid?: string
    minBalanceDue?: string
    maxBalanceDue?: string
    createdDateStart?: string
    createdDateEnd?: string
}

interface TenantBillFilterChipsProps {
    appliedFilters: TenantBillFilters
    onClearFilter: (field: keyof TenantBillFilters) => void
}

const TenantBillFilterChips: React.FC<TenantBillFilterChipsProps> = ({
    appliedFilters,
    onClearFilter,
}) => {
    const classes = useStyles()

    // Count active filters
    const activeFiltersCount = Object.keys(appliedFilters).filter(
        (key) => appliedFilters[key as keyof TenantBillFilters],
    ).length

    if (activeFiltersCount === 0) {
        return null
    }

    return (
        <Box style={{ marginTop: 8 }}>
            {appliedFilters.status && (
                <Chip
                    label={`Status: ${
                        appliedFilters.status.charAt(0).toUpperCase() +
                        appliedFilters.status.slice(1)
                    }`}
                    size="small"
                    onDelete={() => onClearFilter('status')}
                    className={classes.activeFiltersChip}
                />
            )}
            {appliedFilters.search && (
                <Chip
                    label={`Search: ${appliedFilters.search}`}
                    size="small"
                    onDelete={() => onClearFilter('search')}
                    className={classes.activeFiltersChip}
                />
            )}
            {appliedFilters.paymentStatus && (
                <Chip
                    label={`Payment: ${
                        appliedFilters.paymentStatus.charAt(0).toUpperCase() +
                        appliedFilters.paymentStatus.slice(1)
                    }`}
                    size="small"
                    onDelete={() => onClearFilter('paymentStatus')}
                    className={classes.activeFiltersChip}
                />
            )}
            {appliedFilters.isOverdue && (
                <Chip
                    label={`Overdue: ${
                        appliedFilters.isOverdue === 'true' ? 'Yes' : 'No'
                    }`}
                    size="small"
                    onDelete={() => onClearFilter('isOverdue')}
                    className={classes.activeFiltersChip}
                />
            )}
            {appliedFilters.dueDateStart && (
                <Chip
                    label={`Due Date: ${appliedFilters.dueDateStart}${
                        appliedFilters.dueDateEnd
                            ? ` - ${appliedFilters.dueDateEnd}`
                            : ''
                    }`}
                    size="small"
                    onDelete={() => onClearFilter('dueDateStart')}
                    className={classes.activeFiltersChip}
                />
            )}
            {appliedFilters.createdDateStart && (
                <Chip
                    label={`Created: ${appliedFilters.createdDateStart}${
                        appliedFilters.createdDateEnd
                            ? ` - ${appliedFilters.createdDateEnd}`
                            : ''
                    }`}
                    size="small"
                    onDelete={() => onClearFilter('createdDateStart')}
                    className={classes.activeFiltersChip}
                />
            )}
            {appliedFilters.minAmount && (
                <Chip
                    label={`Amount: $${appliedFilters.minAmount}${
                        appliedFilters.maxAmount
                            ? ` - $${appliedFilters.maxAmount}`
                            : '+'
                    }`}
                    size="small"
                    onDelete={() => onClearFilter('minAmount')}
                    className={classes.activeFiltersChip}
                />
            )}
            {appliedFilters.maxAmount && !appliedFilters.minAmount && (
                <Chip
                    label={`Amount: Up to $${appliedFilters.maxAmount}`}
                    size="small"
                    onDelete={() => onClearFilter('maxAmount')}
                    className={classes.activeFiltersChip}
                />
            )}
            {appliedFilters.minAmountPaid && (
                <Chip
                    label={`Paid: $${appliedFilters.minAmountPaid}${
                        appliedFilters.maxAmountPaid
                            ? ` - $${appliedFilters.maxAmountPaid}`
                            : '+'
                    }`}
                    size="small"
                    onDelete={() => onClearFilter('minAmountPaid')}
                    className={classes.activeFiltersChip}
                />
            )}
            {appliedFilters.maxAmountPaid && !appliedFilters.minAmountPaid && (
                <Chip
                    label={`Paid: Up to $${appliedFilters.maxAmountPaid}`}
                    size="small"
                    onDelete={() => onClearFilter('maxAmountPaid')}
                    className={classes.activeFiltersChip}
                />
            )}
            {appliedFilters.minBalanceDue && (
                <Chip
                    label={`Balance: $${appliedFilters.minBalanceDue}${
                        appliedFilters.maxBalanceDue
                            ? ` - $${appliedFilters.maxBalanceDue}`
                            : '+'
                    }`}
                    size="small"
                    onDelete={() => onClearFilter('minBalanceDue')}
                    className={classes.activeFiltersChip}
                />
            )}
            {appliedFilters.maxBalanceDue && !appliedFilters.minBalanceDue && (
                <Chip
                    label={`Balance: Up to $${appliedFilters.maxBalanceDue}`}
                    size="small"
                    onDelete={() => onClearFilter('maxBalanceDue')}
                    className={classes.activeFiltersChip}
                />
            )}
        </Box>
    )
}

export default TenantBillFilterChips
